import {Component} from 'react';
import h from 'react-hyperscript';
import './FourCs.scss';
import {p, subhead} from 'Components/Typography/Typography';
import Image from 'Components/Image/Image';
import RemainingProducts from './RemainingProducts';

class Bucket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collaboration_open: false,
      communication_open: false,
      creativity_open: false,
      critical_thinking_open: false,
    };
    this.closeRemainingProducts = this.closeRemainingProducts.bind(this);
  }

  openRemainingProducts(e) {
    e.preventDefault();
    const bucket = `${e.currentTarget.getAttribute('databucket')}`;
    const _targetState = `${bucket}_open`;
    const stateObj = {
      [_targetState]: true,
    };
    this.setState(stateObj);
  }

  closeRemainingProducts(bucket) {
    const stateObj = {
      [`${bucket}_open`]: false,
    };
    this.setState(stateObj);
  }

  render() {
    return (
      h('div', {
        key: `bucket--${this.props.bucketId}`,
        className: 'bucket',
      }, [
        h(subhead, {
          className: 'margin-bottom--micro',
        }, this.props.bucketTitle),

        h('div', {
          key: 'bucket-products',
          className: 'flex flex--wrap-all',
        }, this.props.totalProducts.map((prod, i) => {
          if (this.props.activeProducts.includes(prod.id)) {
            return (
              h('div', {
                key: `prod--${i}`,
                id: `chip--${prod.id}`,
                className:
                  'chip flex flex--space-between--all margin-bottom--md-2',
                dataproduct: prod.id,
                databucket: this.props.bucketId,
                onClick: (e) => {
                  this.props.handleRemoveFromBucket(e);
                },
              }, [
                h('div', {
                  className: 'flex',
                }, [
                  h(Image, {
                    src: prod.icon,
                    srcset: {
                      standard: prod.icon,
                      retina: prod.icon_2x,
                    },
                    className: 'padding-right--micro product-icon',
                  }, null),
                  h(p, null, prod.title),
                ]),
                h('span', {
                  className: 'material-icons text--grey',
                }, 'close'),
              ])
            );
          } return null;
        })),

        h('div', {
          className: 'add-c',
          databucket: this.props.bucketId,
          onClick: (e) => {
            this.openRemainingProducts(e);
          },
        }, h('span', {
          className: 'material-icons text--grey',
        }, 'add')),

        h(RemainingProducts, {
          isExpanded: this.state[`${this.props.bucketId}_open`],
          totalProducts: this.props.totalProducts,
          remainingProducts: this.props.remainingProducts,
          handleAddToBucket: this.props.handleAddToBucket,
          bucket: this.props.bucketId,
          closeRemainingProducts: this.closeRemainingProducts,
        }, null),

      ])
    );
  }
}

export default Bucket;
